import React from 'react';

interface IYandexAltIconProps {
    size?: number;
    color?: string;
    altColor?: string;
}

export const YandexAltIcon: React.FC<IYandexAltIconProps> = ({ size = 24, color = "#FC5233", altColor = "white" }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 50C0 22.3857 22.3857 0 50 0C77.6142 0 100 22.3857 100 50C100 77.6142 77.6142 100 50 100C22.3857 100 0 77.6142 0 50Z" fill={color}/>
            <path d="M57.3726 28.0016H52.3117C43.6376 28.0016 39.3001 32.3391 39.3001 38.845C39.3001 46.0741 42.1917 49.6883 48.6976 54.0258L53.7576 57.64L39.3001 80.05H27.7334L41.4684 59.8091C33.5167 54.0258 29.1792 48.9658 29.1792 39.5683C29.1792 28.0016 37.1309 20.05 52.3117 20.05H67.4926V80.05H57.3726V28.0016Z" fill={altColor}/>
        </svg>
    );
};
